import React, { useState, useRef } from 'react';
import NumberFormatDecorator from '../../composents/NumberFormat';
import Btn from '../../ui/Btn';
import resources from '../../services';
import moment from 'moment';
import MainPage from '../../composents/MainPage';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const title = 'General';
const headers = {
	icon: 'feather icon-bar-chart-2',
	title: title,
	description: 'track all information',
};

const column = {
	consumers: [
		{
			label: 'Consumer ID',
			field: 'code',
		},
		{
			label: 'consumer name',
			field: 'surname',
		},
		{ label: 'Email', field: 'email' },
		{ label: 'Client', field: 'client', render: ['name'] },
		{ label: 'created at', field: 'createdAt', isDate: true },
	],
	zones: [
		{ label: 'Zone name', field: 'zone' },
		{
			label: 'Zone location',
			field: 'location',
		},
		{
			label: 'Note',
			field: 'description',
		},
		{ label: 'Client', field: 'client', render: ['name'] },
		{ label: 'created at', field: 'createdAt', isDate: true },
	],
	meters: [
		{
			label: 'serial number',
			field: 'numero_de_serie',
		},
		{ label: 'HWD_ID', field: 'code' },
		{
			label: 'Mac address',
			field: 'mac',
		},
		{
			label: 'Specs',
			field: 'systemSpecs',
		},
		{
			label: 'Status',
			field: 'status',
			renderStyle: (data) => {
				return (
					<p>
						{data.status === 1 && (
							<label className="form-label label label-success">
								active
							</label>
						)}
						{data.status === 2 && (
							<label className="form-label label label-danger">
								inactive
							</label>
						)}
					</p>
				);
			},
		},
		{ label: 'Client', field: 'client', render: ['name'] },
		{ label: 'created at', field: 'createdAt', isDate: true },
	],
	cards: [
		{
			label: 'Card id',
			field: 'cardId',
		},
		{
			label: 'Card number',
			field: 'cardNumber',
		},
		{
			label: 'Card Type',
			field: 'cardType',
		},
		{
			label: 'Balance',
			field: 'balance',
			renderStyle: (data) => {
				return data?.balance.toFixed(3);
			},
		},
		{
			label: 'card validity',
			field: 'validityTo',
			isDate: true,
		},
		{
			label: 'Status',
			field: 'status',
			renderStyle: (data) => {
				return (
					<p>
						{data.status === 1 && (
							<label className="form-label label label-success">
								active
							</label>
						)}
						{data.status === 2 && (
							<label className="form-label label label-danger">
								inactive
							</label>
						)}
					</p>
				);
			},
		},
		{ label: 'Consumer', field: 'user', render: ['surname'] },
		{ label: 'Client', field: 'client', render: ['name'] },
		{ label: 'created at', field: 'createdAt', isDate: true },
	],
	consumptions: [
		{
			label: 'Consumer ',
			field: 'user',
			render: ['surname'],
		},
		{
			label: 'Consumption',
			field: 'consumption',
		},
		{
			label: 'Card number',
			field: 'card',
			render: ['cardNumber'],
		},
		{
			label: 'Zone',
			field: 'zone',
			render: ['zone'],
		},
		{
			label: 'Meter',
			field: 'meter',
			render: ['code'],
		},
		{
			label: 'Date ',
			field: 'dateUse',
			// isDate: true,
		},
		{
			label: 'Time ',
			field: 'timeUse',
			// isTime: true,
		},
		{ label: 'created at', field: 'createdAt', isDate: true },
	],
	topUp: [
		{
			label: 'Consumer ',
			field: 'consumer',
			render: ['surname'],
		},
		{
			label: 'Card number',
			field: 'card',
			render: ['cardNumber'],
		},
		{
			label: 'Subscriptions',
			field: 'subscriptions',
			render: ['title'],
		},
		{
			label: 'Water quantity',
			field: 'datas',
			render: ['quantity'],
		},
		{
			label: 'Cost',
			field: 'datas',
			render: ['cost'],
		},
		{
			label: 'Payment',
			field: 'datas',
			render: ['type'],
		},
		{ label: 'created at', field: 'createdAt', isDate: true },
	],
};

export default function GeneralPage() {
	const [filter, setFilter] = useState(false),
		[rsKey, setRSKey] = useState(false),
		[reKey, setREKey] = useState(false),
		[skey, setSkey] = useState(false),
		[type, setType] = useState(''),
		[range, setRange] = useState(''),
		[limit, setLimit] = useState(5),
		[page, setPage] = useState(1),
		[data, setData] = useState([]),
		[details, setDetails] = useState({});
	const inputRef = useRef(null);

	const from = details?.pagingCounter;
	const to = details?.offset * details?.limit;
	const total = details?.totalDocs;

	const getParams = () => {
		let params = '';
		if (range.startsWith('?')) {
			params = `${range}`;
		} else {
			params = `?${range}`;
		}
		return `${params}&${type}`;
	};

	const onLimitChange = async (e) => {
		setLimit(e.target.value);
		setPage(1);

		get(getParams(), e.target.value, 1);
	};

	const onPageChange = async (e, item) => {
		e.preventDefault();
		setPage(item);
		get(getParams(), limit, item);
	};

	const get = async (params, limit_data, page_data) => {
		setFilter(true);
		let response = await resources.stats
			.general(`${params}&limit=${limit_data}&page=${page_data}`)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (response.status === 200) {
			const filter = response.data
				.filter((e) => {
					const keys = Object.keys(e);
					if (keys.length > 0) {
						return keys[0] === 'datas';
					}

					return false;
				})
				.map((e) => Object.values(e)[0]);
			if (filter.length > 0) {
				setDetails(filter[0]);
			}

			setData(
				response.data.filter((e) => {
					const keys = Object.keys(e);
					if (keys.length > 0) {
						return keys[0] !== 'datas';
					}

					return false;
				})
			);
		}
		setFilter(false);
	};

	const detail = async (params) => {
		let type = '';
		if (range.length === 0) {
			type = `?type=${params}`;
		} else if (range.startsWith('?')) {
			type = `${range}type=${params}`;
		} else {
			type = `?${range}type=${params}`;
		}
		setType(`type=${params}`);
		await get(type, limit, page);
	};

	async function filerArticle(e) {
		e.preventDefault();

		let formData = new FormData(e.target);
		const value = Object.fromEntries(formData.entries());
		let params = '?';
		for (let key in value) {
			if (value[key].length > 0) {
				if (key === 's') {
					params = `${params}${key}=${value[key]}&`;
				} else {
					params = `${params}${key}=${moment(value[key]).format(
						'DD-MM-YYYY'
					)}&`;
				}
			}
		}
		setRange(params);
		// setType('');
		console.log(params + '&' + type);
		await get(params + '&' + type, limit, page);
	}

	useEffect(() => {
		get('?', limit, page);
	}, []);

	const onClear = () => {
		setRSKey((e) => !e);
		setREKey((e) => !e);
		setSkey((e) => !e);
		setData([]);
		setRange('');
		setType('');
		setLimit(5);
		setPage(1);
		get('?', limit, page);
	};

	return (
		<MainPage headers={headers}>
			<form onSubmit={filerArticle}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-12">
						<div className="card">
							<div className="row card-body">
								<div className="col-3">
									<input
										key={rsKey}
										className="form-control"
										type="date"
										name="start"
									/>
								</div>
								<div className="col-3">
									<input
										key={reKey}
										className="form-control"
										type="date"
										name="end"
									/>
								</div>
								<div className="col-3">
									<div className="input-group">
										<input
											key={skey}
											className="form-control border-end-0 border"
											type="text"
											placeholder="search"
											name="s"
										/>
										<span>
											<button
												className="btn btn-outline-secondary bg-white border-start-0 border"
												type="button"
												// onClick={OnSearchClick}
											>
												<i
													class="feather icon-search"
													id="general_search"
												></i>
											</button>
										</span>
									</div>
								</div>

								<div className="col-3">
									<div className="row justify-content-left">
										<div className="col-6">
											<Btn
												onLoad={filter}
												class="btn waves-effect waves-light btn-primary"
												type="submit"
											>
												<i className="feather icon-search"></i>{' '}
												Apply
											</Btn>
										</div>
										<div className="col-6">
											<Btn
												onClick={onClear}
												class="btn waves-effect waves-light btn-primary"
												type="button"
											>
												<i className="feather icon-trash"></i>{' '}
												Clear
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
			{filter ? (
				<div class="d-flex align-items-center justify-content-center">
					<div class="spinner-grow" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</div>
			) : (
				<>
					<div className="row">
						{data
							.filter((e) => {
								const keys = Object.keys(e);
								if (keys.length > 0) {
									return keys[0] !== 'datas';
								}

								return false;
							})
							.map((e, k) => {
								const keys = Object.keys(e);
								let field = '';
								let fieldShow = '';
								let value = 0;
								field = keys[0];

								value = e[field];
								if (parseFloat(value) % 1 !== 0) {
									value = value.toFixed(3);
								}

								if (field === 'consumptions') {
									fieldShow = `${field} (L)`;
								} else if (field === 'topUp') {
									fieldShow = `${field} (R)`;
								} else {
									fieldShow = field;
								}

								const style =
									value > 0 ? { cursor: 'pointer' } : {};
								const callback = value > 0 ? detail : () => {};
								return (
									<div
										class="col-xl-4 col-md-12"
										onClick={(e) => callback(field)}
										style={style}
									>
										<div class="card  facebook">
											<div class="card-block">
												<div class="row align-items-center p-10">
													<div class="col">
														<h3 class="m-b-0">
															{/* <i class="feather icon-box"></i> */}
															{fieldShow}
														</h3>
													</div>
													<div class="col-auto">
														<h5 class="m-b-0">
															{value}
														</h5>
													</div>
													{/* <div class="col-auto">
												<i class="feather icon-arrow-up text-c-green"></i>
											</div> */}
												</div>
											</div>
										</div>
									</div>
								);
							})}
					</div>
					{type.length > 0 && (
						<div>
							<div className="card table-card">
								<div className="card-header">
									<h5>details {type.split('=')[1]}</h5>
								</div>

								<div className="card-block">
									<div className="dt-responsive table-responsive">
										<table
											id="simpletable"
											className="table mt-3 nowrap"
										>
											<thead>
												<tr className="table-inverse">
													<th>Num</th>
													{column[
														type.split('=')[1]
													]?.map((i, k) => {
														return (
															<th key={k}>
																{i.label}
															</th>
														);
													})}
												</tr>
											</thead>
											<tbody>
												{details?.docs?.map(
													(el, key) => {
														return (
															<tr key={key}>
																<td>
																	{from + key}
																</td>
																{column[
																	type.split(
																		'='
																	)[1]
																].map(
																	(i, k) => {
																		if (
																			i.renderStyle
																		) {
																			return (
																				<td
																					key={
																						k
																					}
																				>
																					{i.renderStyle(
																						el
																					)}
																				</td>
																			);
																		}

																		if (
																			i.render
																		) {
																			const render =
																				i.render.map(
																					(
																						a
																					) => {
																						if (
																							el.hasOwnProperty(
																								i.field
																							) &&
																							el[
																								i
																									.field
																							]
																						) {
																							return el[
																								i
																									.field
																							][
																								a
																							];
																						}
																					}
																				);
																			return (
																				<td
																					key={
																						k
																					}
																				>
																					{
																						render
																					}
																				</td>
																			);
																		}

																		if (
																			el.hasOwnProperty(
																				i.field
																			)
																		) {
																			if (
																				i.isDate
																			) {
																				return (
																					<td
																						key={
																							k
																						}
																					>
																						{moment(
																							el[
																								i
																									.field
																							]
																						)
																							.utc()
																							.format(
																								'DD/MM/YYYY'
																							)}
																					</td>
																				);
																			}
																			if (
																				i.isTime
																			) {
																				return (
																					<td
																						key={
																							k
																						}
																					>
																						{moment(
																							el[
																								i
																									.field
																							]
																						)
																							.utc()
																							.format(
																								'hh:mm:ss'
																							)}
																					</td>
																				);
																			}
																			if (
																				i.isMoney
																			) {
																				return (
																					<td
																						key={
																							k
																						}
																					>
																						<NumberFormatDecorator
																							value={
																								el[
																									i
																										.field
																								]
																							}
																						/>
																					</td>
																				);
																			} else {
																				return (
																					<td
																						key={
																							k
																						}
																					>
																						{
																							el[
																								i
																									.field
																							]
																						}
																					</td>
																				);
																			}
																		} else {
																			return (
																				<td
																					key={
																						k
																					}
																				/>
																			);
																		}
																	}
																)}
															</tr>
														);
													}
												)}
											</tbody>
										</table>
									</div>

									<div className="row mt-2 p-l-20 p-r-20">
										<div className="col-xs-12 col-sm-12 col-md-2">
											<select
												className="form-select form-control form-control-default fill form-select-sm"
												aria-label="Default select example"
												onChange={onLimitChange}
												value={limit}
											>
												<option value={10}>10</option>
												<option value={20}>20</option>
												<option value={50}>50</option>
												<option value={200}>200</option>
												<option value={500}>500</option>
												<option value={1000}>
													1000
												</option>
												<option value={5000}>
													5000
												</option>
											</select>
										</div>
										<div className="col-xs-12 col-sm-12 col-md-4">
											<div
												className="dataTables_info"
												id="lang-dt_info"
												role="status"
												aria-live="polite"
											>
												Showing {isNaN(from) ? 0 : from}{' '}
												to {isNaN(to) ? 0 : to} of{' '}
												{total ?? 0} entries
											</div>
										</div>
										<div className="col-xs-12 col-sm-12 col-md-6">
											<div
												className="dataTables_paginate paging_simple_numbers"
												id="lang-dt_paginate"
											>
												<ul className="pagination">
													<li
														className={`paginate_button page-item previous
										${!details?.hasPrevPage ? 'disabled' : ''}`}
														id="lang-dt_previous"
													>
														<a
															onClick={(e) =>
																onPageChange(
																	e,
																	details?.prevPage
																)
															}
															href="#!"
															aria-controls="lang-dt"
															data-dt-idx="0"
															tabIndex="0"
															className="page-link"
														>
															Previous
														</a>
													</li>
													<li className="paginate_button page-item active">
														<a
															href="#!"
															aria-controls="lang-dt"
															data-dt-idx="1"
															tabIndex="0"
															className="page-link"
														>
															{page}
														</a>
													</li>
													<li
														className={`paginate_button page-item next ${
															!details?.hasNextPage
																? 'disabled'
																: ''
														}`}
														id="lang-dt_next"
													>
														<a
															onClick={(e) =>
																onPageChange(
																	e,
																	details?.nextPage
																)
															}
															href="#!"
															aria-controls="lang-dt"
															data-dt-idx="3"
															tabIndex="0"
															className="page-link"
														>
															Next
														</a>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					)}
				</>
			)}
		</MainPage>
	);
}
